import * as types from '../actions/health/types';


const INITIAL_STATE = {
  recordHeaders: [],
};

export default function healthReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    // We don't actually use a return object here - we use types hook here solely for loadingState in GetLatestRecord
    case types.GET_LATEST_RECORD:
      return {
        ...state,
      };

    // The latest record is actually returned in this as it is. Currently, there is no need to treat latestRecord as it's own thing.
    case types.RECORD_HEADERS:
      return {
        ...state,
        recordHeaders: action.payload,
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/healthReducer.js